import React from 'react';
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  MainContent,
  SubTitle,
} from '../../../../../components/StyledComponents';
import Input from '../../../../../components/InputControlled';
import TextArea from '../../../../../components/TextArea';
import { useForm } from 'react-hook-form';
import { valueIsRequired } from '../../../../../utils/regex';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { BaSeDialogContext } from '@base/react';
import Spinner from 'react-spinner-material';
import { useApp } from '../../../../../context/app';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';
import { formatDefaultValueSelectRemoveMask } from '../../../../../utils/mask';

export const IncluirPerfilUsuario = () => {
  const { setRenderIncludeScreen } = useApp();
  const { control, handleSubmit, formState, reset } = useForm({
    defaultValues: {
      nome: '',
      tipo: '',
      descricao: '',
      acaoRegistro: '',
      regrasServico: '',
      status: '',
    },
  });
  const { isSubmitting } = formState;
  const { showModal } = React.useContext(BaSeDialogContext);

  const handleGoHome = () => {
    setRenderIncludeScreen(false);
  };

  const submitForm = async (dataForm) => {
    const dataToSubmit = {
      nome: formatDefaultValueSelectRemoveMask(dataForm.nome),
      descricao: dataForm.descricao,
      ativo: true,
    };
    try {
      const response = await PerfilUsuarioService.savePerfil(dataToSubmit);
      handleModalStatus({
        type: 'success',
        msgOnSuccess: 'Perfil de usuário adicionado com sucesso.',
        onCloseModal: handleGoHome,
        showModal,
      });
      return response;
    } catch (e) {
      if (
        e.response?.data?.message.includes('Já existe um perfil com esse nome')
      ) {
        handleModalStatus({
          type: 'hasExist',
          msgOnHasExist:
            'Este perfil de usuário já existe. É necessário que você defina um nome diferente para continuar.',
          showModal,
        });
      } else {
        handleModalStatus({
          type: 'error',
          showModal,
        });
      }
    }
  };

  return (
    <MainContent>
      <SubTitle color="#00ccff">
        <h3>Perfil de usuário: Incluir</h3>
      </SubTitle>

      <FormContainer>
        <div style={{ flex: 1 }}>
          <Input
            name="nome"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Nome do perfil"
            maxLength={140}
            borderRadius="6px"
          />
          <TextArea
            name="descricao"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Descrição"
            borderRadius="6px"
          />
        </div>

        <div style={{ flex: 1, paddingBottom: '1rem' }}>
          <FlexDirectionRow
            position={'end'}
            align={'end'}
            style={{
              marginRight: '40px',
              width: '100%',
              height: '100%',
            }}
          >
            <Button
              type="button"
              backgroundColor={'#9CA2A8'}
              onClick={() => reset()}
              style={{
                marginRight: '20px',
              }}
            >
              Limpar
            </Button>

            <Button
              href="#"
              disabled={isSubmitting}
              onClick={handleSubmit(submitForm)}
            >
              {isSubmitting ? (
                <Spinner radius={5} color={'#fff'} stroke={2} visible={true} />
              ) : (
                'Incluir perfil'
              )}
            </Button>
          </FlexDirectionRow>
        </div>
      </FormContainer>
    </MainContent>
  );
};
